// extracted by mini-css-extract-plugin
export default {"mainContainer":"allCommentsComponent_mainContainer__5x8c-"};